import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import store from '../store'
import router from '../router'

const service = axios.create({
  baseURL: '/api',
  timeout: 120000
})

service.interceptors.request.use(
  config => {
    const token = store.state.token
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  response => {
    const contentType = response.headers['content-type'] || '';
    if (contentType.includes('text/csv') || contentType.includes('application/octet-stream') || contentType.includes('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')) {
      return { __blob: response };
    }
    const res = response.data
    if (res.code !== 200) {
      Message.error(res.message || '请求失败')
      return Promise.reject(new Error(res.message || '请求失败'))
    }
    return res
  },
  error => {
    if (error.response) {
      const status = error.response.status
      let message = '网络错误'

      // 尝试从响应体中获取 message
      if (error.response.data && error.response.data.message) {
        message = error.response.data.message
      } else if (status === 401) {
        message = '登录已失效，请重新登录'
      } else if (status === 403) {
        message = '没有权限访问'
      } else if (status === 404) {
        message = '请求的资源不存在'
      } else if (status >= 500) {
        message = '服务器错误，请稍后重试'
      }

      // 401 时清除 token 并跳转登录页
      if (status === 401) {
        store.dispatch('logout')
        router.push('/login')
        MessageBox.alert(message, '提示', {
          confirmButtonText: '确定',
          type: 'warning'
        })
      } else {
        Message.error(message)
      }
    } else if (error.code === 'ECONNABORTED' || (error.message && error.message.includes('timeout'))) {
      Message.error('请求超时，请稍后重试（大批量导入可能需要更长时间）')
    } else {
      Message.error(error.message || '网络错误')
    }
    return Promise.reject(error)
  }
)

export default service
